<template>
  <div>
    <template v-if="getSpaceplan">
      <div class="w-100 h-100">
        <div class="bounding-element" ref="boundingElement">
          <plan-item
            v-for="item in getSpaceplanItems(id)"
            :key="item.id"
            :plan-item="item"
            :edit-enabled="spaceplan.isEditModeEnabled"
          />
          <img alt="spaceplan image" :src="getSpaceplan.image" />
        </div>
      </div>
      <plan-item-modal-add-form ref="PlanItemModalAddForm" @service-picked="servicePicked" />
      <space-plan-update-modal-form ref="SpacePlanUpdateModalForm" :spaceplan="getSpaceplan" />
    </template>
  </div>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import { mapState, mapGetters, mapActions } from 'vuex';
import PlanItemModalAddForm from '@/components/spaceplan/PlanItemModalAddForm.vue';
import PlanItem from '@/components/spaceplan/PlanItem.vue';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import SpacePlanUpdateModalForm from '@/components/spaceplan/SpacePlanUpdateModalForm';

export default {
  name: 'Spaceplan',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getSpaceplanById',
      'getSpaceplanItems',
    ]),
    ...mapState('app', [
      'spaceplan',
    ]),
    getSpaceplan() {
      return this.getSpaceplanById(this.id);
    },
    getCentralCoordinates() {
      return {
        left: Math.round(this.$refs.boundingElement.offsetWidth / 2),
        top: Math.round(this.$refs.boundingElement.offsetHeight / 2),
      };
    },
    spaceplanName() {
      return this.getSpaceplan ? this.getSpaceplan.name : '';
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('vizualizations'),
          to: { name: 'spaceplans' },
        },
        {
          text: this.spaceplanName,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'addSpaceplanItem',
      'loadSpaceplanItems',
      'removeSpaceplan',
    ]),
    showPlanItemModalAddForm() {
      this.$refs.PlanItemModalAddForm.show();
    },
    showEditSpacePlanForm() {
      this.$refs.SpacePlanUpdateModalForm.show();
    },
    servicePicked(servicesIds) {
      this.addSpaceplanItem({
        // ...this.getCentralCoordinates,
        top: 0,
        left: 0,
        service: servicesIds[0],
        spaceplan: this.id,
      });
    },
    async removeThisSpaceplan() {
      await this.removeSpaceplan(this.id);
      this.$router.push({ name: 'spaceplans' });
    },
  },
  beforeMount() {
    if (this.getSpaceplan === undefined) {
      this.$router.push({ name: 'spaceplans' });
    }
  },
  mounted() {
    this.loadSpaceplanItems(this.id);
  },
  created() {
    eventBus.$on('addSpacePlanItemClicked', this.showPlanItemModalAddForm);
    eventBus.$on('removeSpacePlanClicked', this.removeThisSpaceplan);
    eventBus.$on('editSpacePlanClicked', this.showEditSpacePlanForm);
  },
  destroyed() {
    eventBus.$off('addSpacePlanItemClicked');
    eventBus.$off('removeSpacePlanClicked');
    eventBus.$off('editSpacePlanClicked');
  },
  components: {
    PlanItemModalAddForm,
    PlanItem,
    SpacePlanUpdateModalForm,
  },
};
</script>

<style scoped>
.bounding-element {
  position: relative;
  overflow-x: auto;
}

</style>
